<script setup lang="ts">
  import { Picture } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import {
    AppDownloadPartner,
    type AppStore,
    downloadApp,
    FOOTER_APP_DOWNLOAD_BANNER_NAME,
    getAppStoreDeviceType,
    getVisibleAppStores,
    useDeviceType,
  } from '@/entities/device';
  import { APP_BADGES, type AppBadge } from '../../config/logos';

  const deviceType = useDeviceType();

  const visibleBadges = computed<AppBadge[]>(() => {
    const visibleStores = getVisibleAppStores(deviceType.value);
    return APP_BADGES.filter((badge) => visibleStores.includes(badge.type));
  });

  const onDownload = (store: AppStore): void => {
    downloadApp({
      deviceType: getAppStoreDeviceType(store),
      bannerName: FOOTER_APP_DOWNLOAD_BANNER_NAME,
      partner: AppDownloadPartner.MobileWeb,
    });
  };
</script>

<template>
  <div
    class="footer-app-badges"
    data-testid="footer-app-badges"
  >
    <div
      v-for="badge in visibleBadges"
      :key="badge.file"
      class="footer-app-badges__item"
      :data-testid="`footer-app-badge-${badge.type}`"
      @click="onDownload(badge.type)"
    >
      <Picture
        :path="`app/${badge.file}`"
        :extensions="[]"
        :high-resolution="false"
        fit="contain"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .footer-app-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    &__item {
      display: block;
      flex: 0 0 auto;
      height: 30px;
      width: 100px;
    }
  }
</style>
